import React, { createContext, useContext } from "react";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { useSalePageContext } from "../SalePageContext";

type IWhoIsItForSectionContextValue = {
    hide: boolean;
    title: string;
    whoIsItForList: Array<string>;
};

const initialContextValue: IWhoIsItForSectionContextValue = {
    hide: false,
    title: "",
    whoIsItForList: [],
};

const WhoIsItForSectionContext = createContext(initialContextValue);

export function WhoIsItForSectionContextProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { sectionsData, isPreview } = useSalePageContext();

    const title =
        sectionsData.whoIsItForSection.title ||
        (isPreview ? "&lt;Who is this workshop for title?&gt;" : "");
    const whoIsItForList =
        (isPreview &&
        checkIsArrayEmpty(sectionsData.whoIsItForSection.whoIsItForList)
            ? [
                  "&lt;workshop for pointer 1&gt;",
                  "&lt;workshop for pointer 2&gt;",
                  "&lt;workshop for pointer 3&gt;",
              ]
            : sectionsData.whoIsItForSection.whoIsItForList) || [];

    const contextValue: IWhoIsItForSectionContextValue = {
        hide: checkIsArrayEmpty(whoIsItForList),
        title,
        whoIsItForList,
    };
    return (
        <WhoIsItForSectionContext.Provider value={contextValue}>
            {children}
        </WhoIsItForSectionContext.Provider>
    );
}

export function useWhoIsItForSectionContext() {
    return useContext(WhoIsItForSectionContext);
}
